import { Http } from "@/plugins/http.js";
import dayjs from "dayjs";
import { uniqueId } from "lodash/util.js";

export default {
  namespaced: true,

  state: {
    agenda: [],
    calendar: [],
    closedBlocks: [],
  },

  mutations: {
    TOGGLE_CLOSED_BLOCK(state, payload) {
      if (state.closedBlocks.includes(payload)) {
        state.closedBlocks = state.closedBlocks.filter(el => el !== payload);
      } else {
        state.closedBlocks.push(payload);
      }
    },
    SET_AGENDA(state, payload) {
      state.agenda = payload;
    },

    ADD_AGENDA(state, payload) {
      state.agenda.unshift(payload);
    },

    SET_CALENDAR(state, payload) {
      state.calendar = payload.map(item => {
        return {
          name: item.title || item.name,
          start: item.start,
          end: item.end || "",
          timed: !item.all_day,
          id: item.id,
          doc_id: item.doc_id,
          entity_id: item.entity_id,
          type: item.type,
          doctor: item.doctor,
          status: item.status,
          appointment_id: Number(item.appointment) || null,
        };
      });
    },

    ADD_CALENDAR(state, payload) {
      state.calendar.push({
        name: payload.title,
        start: payload.start,
        end: payload.end || "",
        timed: !payload.all_day,
        doctor: payload.doctor,
      });
    },
  },

  actions: {
    async loadEvents(
      { commit, rootState },
      { start, end } = {
        start: dayjs()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: dayjs()
          .endOf("month")
          .format("YYYY-MM-DD"),
      },
    ) {
      try {
        const response = await Http.get(`v1/customers/${rootState.customer.id}/events`, {
          params: {
            date_start: start,
            date_end: end,
          },
        });

        commit(
          "SET_CALENDAR",
          response.data.data.map(item => {
            if (item.entity_payload) {
              const payload = JSON.parse(item.entity_payload);
              if (payload.title) {
                item.title = payload.title;
              }

              item.start = dayjs(item.start).format("YYYY-MM-DD");
            }
            return item;
          }),
        );
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        commit("SET_CALENDAR", []);
      }
    },

    async loadAgendaEvents(
      { commit, rootState },
      { start, end, ...params } = {
        start: dayjs()
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: dayjs()
          .endOf("month")
          .format("YYYY-MM-DD"),
      },
    ) {
      try {
        const response = await Http.get(`v1/customers/${rootState.customer.id}/events`, {
          params: {
            date_start: start,
            date_end: end,
            ...params,
          },
        });

        commit(
          "SET_AGENDA",
          response.data.data.map(item => {
            if (item.entity_payload) {
              const payload = JSON.parse(item.entity_payload);
              if (payload.title) {
                item.title = payload.title;
              }

              item.date = dayjs(item.start).format("DD.MM.YYYY");
              item.time = dayjs(item.start).format("HH:mm:ss");
            }

            return {
              uuid: uniqueId(),
              title: item.title,
              date: item.date || "",
              time: item.time || "",
              id: item.id,
              doc_id: item.doc_id,
            };
          }),
        );
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        commit("SET_AGENDA", []);
      }
    },
  },
};
